import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { soundNeeded, isUpcoming } from '../../utils/soundRules';
import { field, labelStyle, errorStyle, hintStyle } from '../../components/formStyles';
import { adminAction, loadEngineers, loadSoundAssignments } from './adminShared';

const BAND_SAID = { yes: 'Yes, needs one from us', no: 'No, brings their own' };

/** On an application: does the show need our engineer, and who does it. */
const SoundSection = ({ session, app, onChange }) => {
    const [engineers, setEngineers] = useState([]);
    const [engineer, setEngineer] = useState(undefined); // undefined = loading, null = nobody
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const reload = () => loadSoundAssignments().then((m) => setEngineer(m[app.id] || null)).catch((e) => setError(e.message));
    useEffect(() => {
        loadEngineers().then(setEngineers).catch((e) => setError(e.message));
        loadSoundAssignments().then((m) => setEngineer(m[app.id] || null)).catch((e) => setError(e.message));
    }, [app.id]);

    const run = async (body) => {
        setBusy(true); setError(null);
        try { await adminAction(session, { id: app.id, ...body }); await reload(); await onChange(); }
        catch (e) { setError(e.message); }
        finally { setBusy(false); }
    };

    const needed = soundNeeded(app);
    const override = typeof app.sound_needed === 'boolean' ? String(app.sound_needed) : 'band';
    const booked = isUpcoming(app);
    const pick = (email) => run(email ? { action: 'sound_assign', email } : { action: 'sound_unassign' });
    // someone on the show who has since left the crew still shows in the list
    const options = engineer && !engineers.some((e) => e.email === engineer.email) ? [...engineers, engineer] : engineers;

    return (
        <section style={{ marginBottom: '28px' }}>
            <p style={labelStyle}>Sound</p>
            <div style={{ display: 'grid', gap: '14px', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}>
                <div>
                    <label htmlFor="sound-needed" style={labelStyle}>Needs our engineer</label>
                    <select id="sound-needed" value={override} disabled={busy} style={{ ...field, backgroundColor: '#111' }}
                        onChange={(e) => run({ action: 'sound_set_needed', needed: e.target.value === 'band' ? null : e.target.value === 'true' })}>
                        <option value="band">As the band said: {app.needs_sound_engineer === 'yes' ? 'yes' : 'no'}</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>
                {booked && (
                    <div>
                        <label htmlFor="sound-engineer" style={labelStyle}>Engineer</label>
                        <select id="sound-engineer" value={engineer?.email || ''} disabled={busy || engineer === undefined} style={{ ...field, backgroundColor: '#111' }}
                            onChange={(e) => pick(e.target.value)}>
                            <option value="">{needed ? 'Nobody yet' : 'Nobody'}</option>
                            {options.map((e) => <option key={e.email} value={e.email}>{e.name || e.email}</option>)}
                        </select>
                    </div>
                )}
            </div>
            {error && <p style={errorStyle}>{error}</p>}
            <p style={hintStyle}>
                The band said: {BAND_SAID[app.needs_sound_engineer] || '-'}.{' '}
                {booked
                    ? needed
                        ? 'The sound crew sees this show on their page and can take it; whoever you pick here gets an email with the band\'s contact.'
                        : 'The sound crew does not see this show unless you switch it to Yes.'
                    : 'Once the show is booked, the sound crew sees it if it needs an engineer.'}{' '}
                <Link to="/admin/crew" style={{ color: '#c89b3c' }}>Sound crew</Link>
            </p>
        </section>
    );
};

export default SoundSection;
